import FlutterTrainingComponent from "@/components/FlutterTraining";
import React from "react";

export default function FlutterTraining(): JSX.Element {
  return <FlutterTrainingComponent />;
}
